import React, {useContext} from 'react';
import {useDispatch} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {DeleteIcon} from '~library/svg/DeleteIcon';
import {Typography} from '~library/atoms/Typography';
import {
  UPDATE_PRISTINE_UYO,
  UPDATE_DESIGN_OPTIONS,
} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {charcoal, pebble} from '~libSass/base/_exports.sass';
import {deriveIdFromCanvasObject} from '~/CreateFabricInvitation/utils/canvas';

import './DeleteButton.sass';

export const DeleteButton = ({btnText = '', disabled, semibold = false}) => {
  const {canvas} = useContext(EventCreateContext);
  const dispatch = useDispatch();

  const removeUYOImage = async () => {
    const canvasObjects = canvas.getObjects();
    const activeObject = canvas.getActiveObject();
    let id;
    // eslint-disable-next-line no-underscore-dangle
    if (activeObject?.type === 'uYOImage' || activeObject._originalObject.type === 'uYOImage') {
      // eslint-disable-next-line no-underscore-dangle
      id = activeObject?.id || deriveIdFromCanvasObject(activeObject._originalObject);
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {shouldUseCachedGalleryPhoto: false},
      });
      canvas.remove(activeObject);
      canvas.discardActiveObject();
      canvas.renderAll();
      canvas.fire('object:removed');
      for (const obj of canvasObjects) {
        if (obj.type === 'rect' && obj.fill === 'white' && deriveIdFromCanvasObject(obj) === id) {
          obj.set({backgroundColor: 'rgb(128,128,128,0.5)', fill: 'transparent', type: 'uYOImage'});
          canvas.renderAll();
          canvas.fire('object:modified');
        }
      }

      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: true, id, activeCardEditor: 'intro'},
      });
    }
  };

  return (
    <Button
      variant="secondary"
      size="large"
      fullWidth
      className="delete-uyo-button"
      onClick={removeUYOImage}
      data-qa-id="delete-uyo-button"
    >
      <DeleteIcon className="action_button__upload" color={disabled ? pebble : charcoal} />
      {btnText && (
        <Typography
          variant="paragraph3"
          size="medium"
          color={disabled ? 'pebble' : 'charcoal'}
          semibold={semibold}
        >
          {btnText}
        </Typography>
      )}
    </Button>
  );
};
